import {addHours, format} from 'date-fns'
import {dateToUTC} from '@/utils/helpers'

export default function (rs) {
    rs.expirationTime = format(dateToUTC(addHours(new Date(), 10)), 'yyyy-MM-dd HH:mm')

    return rs
}
